import { EventEmitter, ElementRef, OnInit, } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
var AppCropperImageComponent = /** @class */ (function () {
    function AppCropperImageComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.isValid = false;
        this.imgSelected = new EventEmitter();
        this.format = "post";
        this.imageChangedEvent = "";
        this.croppedImage = "";
        this.maintainAspectRatio = true;
        this.resizeToWidth = 0;
        this.resizeToHeight = 0;
    }
    Object.defineProperty(AppCropperImageComponent.prototype, "croppedImageBg", {
        get: function () {
            return this.sanitizer.bypassSecurityTrustStyle("url(" + this.croppedImage + ")");
        },
        enumerable: true,
        configurable: true
    });
    AppCropperImageComponent.prototype.ngOnInit = function () {
        this.aspectRatio = 16 / 9;
        // this.aspectRatio = 4 / 3;
        if (this.format === "free") {
            this.maintainAspectRatio = false;
        }
        if (this.format === "cover") {
            // this.aspectRatio = 4 / 1;
            this.aspectRatio = 16 / 9;
        }
        if (this.format === "poll") {
            this.aspectRatio = 16 / 18;
        }
        if (this.format === "logo") {
            this.aspectRatio = 1 / 1;
        }
        this.clicked();
    };
    AppCropperImageComponent.prototype.fileChangeEvent = function (event) {
        var fsize = event.currentTarget.files[0].size;
        var file = Math.round(fsize / 1024);
        if (file >= 5120) {
            alert("File too Big, please select a file less than 5mb");
            return;
        }
        this.imageChangedEvent = event;
        this.isValid = false;
    };
    AppCropperImageComponent.prototype.imageCropped = function (image) {
        var _this = this;
        this.croppedImage = image.base64;
        // console.log(image.width, image.height);
        setTimeout(function () {
            _this.isValid = true;
        }, 1000);
    };
    AppCropperImageComponent.prototype.loadImageFailed = function (e) {
        // show message
        console.log("Error", e);
    };
    AppCropperImageComponent.prototype.onSelectImage = function () {
        // console.log(this.croppedImage);
        this.imgSelected.emit(this.croppedImage);
    };
    AppCropperImageComponent.prototype.clicked = function () {
        this.fileInput.nativeElement.click();
    };
    return AppCropperImageComponent;
}());
export { AppCropperImageComponent };
